import axios from 'axios'
import { notification } from 'antd'

import config from '../config'

function configDefaultRequest(axios) {
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  axios.defaults.headers.common['Access-Control-Request-Methods'] = '*'

  axios.interceptors.response.use(
    response => response,
    error => {
      const response = error.response || {}

      const data = response.data || {}
      const status = response.status || 500

      if (status === 401) {
        notification.error({
          message: 'Unauthorized',
          description: 'Please contact to the administrator.'
        })
      } else if (status === 404) {
        // do nothing
      } else if (status >= 400 && status <= 511) {
        notification.error({
          message: 'Error',
          description: data.message || response.message ||
                        'Unable to process your request please try later'
        })
      }

      return Promise.reject(error)
    }
  )

  return axios
}

/**
 * @deprecated
 */
const request = axios.create({
  baseURL: config.uploadBaseUrl,
  headers: {
    Authorization: `Bearer ${config.uploadAuthorization}`
  }
})

const mediaManagerRequest = axios.create({
  baseURL: config.mediaManagerBaseUrl,
  headers: {
    Authorization: `Bearer ${config.mediaManagerApiToken}`
  }
})

const simulate = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data)
    }, 2000)
  })
}

configDefaultRequest(request)
configDefaultRequest(mediaManagerRequest)

export default request

export {
  axios,
  configDefaultRequest,
  mediaManagerRequest,
  simulate
}
